module.exports = __webpack_public_path__ + "img/purchaseStorage.aa745718.png";